import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { PHOTOS } from "@/data/content";

export default function PhotoBand() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section ref={ref} data-testid="photo-band" className="relative h-[70vh] overflow-hidden">
      <motion.img
        src={PHOTOS.drewSet}
        alt="Susan Grau with Valerie Bertinelli on the set of The Drew Barrymore Show"
        style={{ y, scale: 1.25 }}
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-[#6B5D4F]/45" aria-hidden="true" />
      <div className="absolute inset-0 bg-gradient-to-l from-[#6B5D4F]/75 via-[#6B5D4F]/20 to-transparent" aria-hidden="true" />
      <div className="relative flex h-full items-center justify-end px-6 lg:px-16">
        <motion.blockquote
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 1, ease: [0.76, 0, 0.24, 1] }}
          className="max-w-2xl text-right"
        >
          <p className="font-body text-[0.65rem] font-medium uppercase tracking-[0.5em] text-[#C5A059]">
            Editorial 02 — The Drew Set
          </p>
          <p className="mt-8 font-serif2 text-4xl font-medium italic leading-snug text-[#FDFAF4] md:text-5xl">
            "Pain may become part of your story — it never has to become your identity."
          </p>
          <footer className="mt-10 flex items-center justify-end gap-4">
            <span className="font-body text-[0.65rem] font-medium uppercase tracking-[0.4em] text-[#C5A059]">
              Susan Grau · The Drew Barrymore Show
            </span>
            <span className="h-px w-10 bg-[#C5A059]" aria-hidden="true" />
          </footer>
        </motion.blockquote>
      </div>
    </section>
  );
}
